var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartReporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.689 138.782C125.689 136.171 123.557 134.092 120.999 134.092C118.387 134.092 116.309 136.224 116.309 138.782C116.309 140.595 117.321 142.193 118.867 142.94V144.805H123.184V142.94C124.676 142.193 125.689 140.595 125.689 138.782Z",
    fill: "#FFDA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.344 146.032H118.601C118.388 146.032 118.174 145.818 118.174 145.605C118.174 145.392 118.388 145.179 118.601 145.179H123.344C123.557 145.179 123.77 145.392 123.77 145.605C123.77 145.872 123.611 146.032 123.344 146.032Z",
    fill: "#080C51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.344 144.912H118.601C118.388 144.912 118.174 144.699 118.174 144.486C118.174 144.273 118.388 144.059 118.601 144.059H123.344C123.557 144.059 123.77 144.273 123.77 144.486C123.77 144.752 123.611 144.912 123.344 144.912Z",
    fill: "#1E334E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.344 147.204H118.601C118.388 147.204 118.174 146.99 118.174 146.777C118.174 146.564 118.388 146.351 118.601 146.351H123.344C123.557 146.351 123.77 146.564 123.77 146.777C123.77 146.99 123.611 147.204 123.344 147.204Z",
    fill: "#1E334E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.595 147.577C122.595 148.483 121.849 149.176 120.996 149.176C120.09 149.176 119.397 148.429 119.397 147.577H122.595Z",
    fill: "#1E334E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.05 56.225L103.375 56.25L103.325 143L42 142.975L42.05 56.225Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6497 101.85C79.3247 102.875 78.7997 103.775 78.0747 104.55L83.4497 112.025C86.1497 109.7 88.0997 106.5 88.8497 102.85L79.6497 101.85Z",
    fill: "#A6DAE9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1748 92.3502C77.2998 93.0002 79.6748 95.6252 79.9748 98.8752L89.1498 99.8752C89.1498 99.7752 89.1748 99.6752 89.1748 99.5752C89.1748 90.9752 82.5998 83.9252 74.1998 83.1752V92.3502H74.1748Z",
    fill: "#F99B1C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2498 94.6251C68.2748 93.5001 69.6248 92.6752 71.1748 92.3502V83.1501C66.2748 83.6001 62.0248 86.1751 59.2998 89.9501L67.2498 94.6251Z",
    fill: "#D16408"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6497 106.3C74.7497 106.7 73.7247 106.95 72.6747 106.95C68.5997 106.95 65.2997 103.65 65.2997 99.5751C65.2997 98.7501 65.4747 97.9502 65.7247 97.2252L57.7997 92.5251C56.7997 94.6501 56.1997 97.0501 56.1997 99.5751C56.1997 108.675 63.5747 116.05 72.6997 116.05C75.7497 116.05 78.5747 115.225 81.0247 113.775L75.6497 106.3Z",
    fill: "#D16408"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M56.05 62.0751H48.375V64.3001H56.05V62.0751Z",
    fill: "#F99B1C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.05 67.1501H48.375V69.3751H56.05V67.1501Z",
    fill: "#D16408"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.05 72.25H48.375V74.475H56.05V72.25Z",
    fill: "#F59C52"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.05 77.3251H48.375V79.5501H56.05V77.3251Z",
    fill: "#F99B1C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.975 62.175H61.25V64.7001H96.975V62.175Z",
    fill: "#CCCCCC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M96.975 69.675H61.25V72.175H96.975V69.675Z",
    fill: "#CCCCCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M96.975 77.2001H61.25V79.7001H96.975V77.2001Z",
    fill: "#CCCCCC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96.975 73.4501H61.25V75.9501H96.975V73.4501Z",
    fill: "#CCCCCC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.975 65.925H61.25V68.425H96.975V65.925Z",
    fill: "#CCCCCC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M50 118.35H48.375V135.6H50V118.35Z",
    fill: "#CCCCCC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96.975 135.6H48.375V137.225H96.975V135.6Z",
    fill: "#CCCCCC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6244 127.925H54.2744V135.6H58.6244V127.925Z",
    fill: "#F58120"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6249 124.1H54.2749V127.925H58.6249V124.1Z",
    fill: "#FFE1CA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66.725 124.6H62.375V135.6H66.725V124.6Z",
    fill: "#F58120"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.725 122.4H62.375V124.6H66.725V122.4Z",
    fill: "#FFE1CA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M74.85 130.025H70.5V135.6H74.85V130.025Z",
    fill: "#F58120"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M74.85 126H70.5V130H74.85V126Z",
    fill: "#FFE1CA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M82.975 132.4H78.625V135.6H82.975V132.4Z",
    fill: "#F58120"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M82.975 129.2H78.625V132.4H82.975V129.2Z",
    fill: "#FFE1CA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M103.35 56.25H85.675V131.85H103.35V56.25Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.675 43L149.425 43.025L149.375 128.95L88.625 128.925L88.675 43Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.2994 87.4001L101.549 87.4251L101.524 92.2001L96.2744 92.1751L96.2994 87.4001Z",
    fill: "#F58120"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M107.599 85.3501H102.349V92.1751H107.599V85.3501Z",
    fill: "#F59C52"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M113.674 80.5751H108.424V92.2001H113.674V80.5751Z",
    fill: "#F59C52"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M119.75 82.2001H114.5V92.2001H119.75V82.2001Z",
    fill: "#F3B785"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M125.799 87.2001H120.549V92.2001H125.799V87.2001Z",
    fill: "#F3B785"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M131.724 85.3H126.474V92.2001H131.724V85.3Z",
    fill: "#FCB274"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M137.774 82.175H132.524V92.175H137.774V82.175Z",
    fill: "#FCB274"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M143.849 75.5751H138.599V92.2001H143.849V75.5751Z",
    fill: "#F58120"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M116.975 99.275H94.2V100.8H116.975V99.275Z",
    fill: "#CCCCCC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M116.975 101.9H94.2V103.425H116.975V101.9Z",
    fill: "#CCCCCC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M116.975 104.55H94.2V106.075H116.975V104.55Z",
    fill: "#CCCCCC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M116.975 107.2H94.2V108.725H116.975V107.2Z",
    fill: "#CCCCCC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M116.975 109.85H94.2V111.375H116.975V109.85Z",
    fill: "#CCCCCC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M116.975 112.5H94.2V114.025H116.975V112.5Z",
    fill: "#CCCCCC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M116.975 115.15H94.2V116.675H116.975V115.15Z",
    fill: "#CCCCCC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M105.575 117.8H94.2V119.325H105.575V117.8Z",
    fill: "#CCCCCC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M143.825 99.275H121.05V100.775H143.825V99.275Z",
    fill: "#CCCCCC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M143.825 101.925H121.05V103.45H143.825V101.925Z",
    fill: "#CCCCCC"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M143.825 104.575H121.05V106.1H143.825V104.575Z",
    fill: "#CCCCCC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M143.825 107.225H121.05V108.725H143.825V107.225Z",
    fill: "#CCCCCC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M143.825 109.875H121.05V111.375H143.825V109.875Z",
    fill: "#CCCCCC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M143.825 112.525H121.05V114.05H143.825V112.525Z",
    fill: "#CCCCCC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M143.825 115.15H121.05V116.675H143.825V115.15Z",
    fill: "#CCCCCC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M137.075 117.8H121.05V119.3H137.075V117.8Z",
    fill: "#CCCCCC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4751 71.65L96.1001 69.75L113.425 56.975L124.675 64.675L142.65 52.375L143.975 54.3L124.675 67.525L113.475 59.875L97.4751 71.65Z",
    fill: "#FFA65C"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M144.15 58.425H142.275V54.275H138.125V52.4H144.15V58.425Z",
    fill: "#F58120"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M127.1 65.675C127.1 64.25 125.95 63.1 124.525 63.1C123.1 63.1 121.95 64.25 121.95 65.675C121.95 67.1 123.1 68.25 124.525 68.25C125.95 68.25 127.1 67.1 127.1 65.675Z",
    fill: "#F58120"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M116.075 58.425C116.075 57 114.925 55.85 113.5 55.85C112.075 55.85 110.925 57 110.925 58.425C110.925 59.85 112.075 61 113.5 61C114.9 61 116.075 59.85 116.075 58.425Z",
    fill: "#F58120"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartReporting);
export default __webpack_public_path__ + "static/media/smartReporting.025a82c0c7fdadaeef250f46a44f52ff.svg";
export { ForwardRef as ReactComponent };